import React, { useEffect } from "react";
import iconLogoWithMascot from "../../assets/svg/icon-logo-with-mascot.svg";
import styled from "styled-components";
import { useNavigate, useSearchParams } from "react-router-dom";
import { isLoggedIn } from "../../utils/utility";

export default function Splash() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    if (sessionStorage.getItem("splash") === "true") {
      navigate("/");
    }

    const navigateTo = () => {
      sessionStorage.setItem("splash", "true");
      navigate(
        params.get("isFirst") === "true"
          ? "/introduction"
          : isLoggedIn()
          ? localStorage.getItem("INACTVE") === "true"
            ? "/survey/age"
            : "/"
          : "/login",
        {
          replace: true,
        }
      );
    };

    const timer = setTimeout(navigateTo, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <SplashStyled>
      <img src={iconLogoWithMascot} alt="" />
      <span>뇌과학자의 확실한 암기 비법</span>
    </SplashStyled>
  );
}

const SplashStyled = styled.div`
  height: 100dvh;
  width: 100dvw;
  background-color: var(--color-main);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > img {
    margin-bottom: 0.4rem;
  }

  & > span {
    font-size: 1.2rem;
    color: var(--color-white);
  }
`;
